import { useDispatch, useSelector } from "react-redux"

import store from "./store"

export type DappDispatch = typeof store.dispatch

export const useDappDispatch: () => DappDispatch = useDispatch
export const useDappSelector = useSelector

export default store

export * from "./reducers"
export * from "./selectors/account"
export * from "./selectors/borrow"
export * from "./selectors/bridge"
export * from "./selectors/deposit"
export * from "./selectors/deposit-action"
export * from "./selectors/donation"
export * from "./selectors/leaderboard"
export * from "./selectors/market"
export * from "./selectors/matsnet"
export * from "./selectors/onboarding"
export * from "./selectors/portal"
export * from "./selectors/receipt-token"
export * from "./selectors/rewards"
export * from "./selectors/store"
export * from "./selectors/ui"
export * from "./selectors/wallet"
export * from "./slices/account"
export * from "./slices/borrow"
export * from "./slices/bridge"
export * from "./slices/deposit"
export * from "./slices/deposit-action"
export * from "./slices/donation"
export * from "./slices/leaderboard"
export * from "./slices/matsnet"
export * from "./slices/onboarding"
export * from "./slices/portal"
export * from "./slices/receipt-token"
export * from "./slices/rewards"
export * from "./slices/store"
export * from "./slices/ui"
export * from "./slices/wallet"
export * from "./thunks/account"
export * from "./thunks/bitcoin"
export * from "./thunks/borrow"
export * from "./thunks/donation"
export * from "./thunks/leaderboard"
export * from "./thunks/mats"
export * from "./thunks/matsnet"
export * from "./thunks/portal"
export * from "./thunks/receipt-token"
export * from "./thunks/session"
export * from "./thunks/store"
export * from "./thunks/transactions"
export * from "./thunks/wallet"
